module.exports = __webpack_public_path__ + "static/media/icon-clock.91891e71.svg";